<template>
  <div>
    <div class="py-1 bg-gray-200 shadow w-full flex justify-between items-center">
      <div class="px-4">
        <p-check class="p-icon p-plain text-gray-700" toggle v-model="isDoneFilter" @change="fetchData(true)">
          <i class="icon fas fa-clipboard-check" slot="extra"></i>
          erledigt
          <i class="icon fas fa-clipboard-list" slot="off-extra"></i>
          <label slot="off-label">offen</label>
        </p-check>
      </div>
      <div class="px-4">
        <p-check class="p-icon p-plain text-gray-700" color="danger-o" toggle v-model="isImportantFilter"
                 @change="fetchData(true)">
          <i class="icon far fa-clock" slot="extra"></i>
          nur Fristen
          <i class="icon far fa-clock" slot="off-extra"></i>
          <label slot="off-label">alle</label>
        </p-check>
      </div>
      <div class="px-4">
        <input class="mx-1 input" @change="fetchData(true)" v-model="searchFilter" placeholder="Suchbegriff"/>
      </div>
      <div class="px-4">
        <Datepicker v-model="fromDateFilter" valueType="format" format="DD.MM.YYYY" class="w-32" @change="fetchData(true)"></Datepicker>
        -
        <Datepicker v-model="untilDateFilter" valueType="format" format="DD.MM.YYYY" class="w-32" @change="fetchData(true)"></Datepicker>
      </div>
      <div class="px-4" v-if="!!dossierId">
        <deadline-create-form-modal :deadline="{dossier_id: dossierId, completion_date: null, is_important: null}" v-on:updated="updated" />
      </div>
      <div class="px-4" v-if="pagination['total_pages'] > 1">
        <span v-if="pagination['page'] > 1" @click="toPage(pagination['page'] - 1)">
          <i class="fas fa-caret-left mr-1 text-primary cursor-pointer"></i>
        </span>
        <select v-model="pagination['page']" class="select" @change="fetchData(false)">
          <option v-for='index in pagination["total_pages"]' :key='index' :value="index">Seite {{ index }}</option>
        </select>
        <span v-if="pagination['page'] < pagination['total_pages']" @click="toPage(pagination['page'] + 1)">
          <i class="fas fa-caret-right ml-1 text-primary cursor-pointer"></i>
        </span>
      </div>
    </div>

<!--    <div class="flex justify-end my-4" v-if="!this.dossierId">-->
<!--      <p-check class="p-default p-fill" color="primary" v-model="isPreliminaryFilter" @change="fetchData()">-->
<!--        Aufrissakten-->
<!--      </p-check>-->
<!--    </div>-->

    <table class="table-auto shadow w-full">
      <tr v-for="deadline in this.deadlines" v-bind:class="{ 'bg-red-100': deadline.is_important }" v-bind:key="deadline.id">
        <td class="px-4 py-2 border-dashed border-t border-gray-200 text-left" v-if="!dossierId">
          <a :href="deadline.dossier_path" class="primary-link">
            <i class="fas fa-folder-open"></i> {{ deadline.dossier_name }}
          </a>
        </td>
        <td class="px-4 py-2 border-dashed border-t border-gray-200 text-left">
          <accordion :title="deadline.title" :active="false" title-classes="text-black"
                     active-title-classes="font-bold">
            <p class="text-gray-900 py-2 whitespace-pre-line">
              {{ deadline.description }}
            </p>
            <div @click="edit(deadline)" class="btn btn-secondary btn-small inline-block my-2">
              <i class="fas fa-edit"></i>
              bearbeiten
            </div>
          </accordion>
          <deadline-edit-form-modal :deadline="deadline" v-on:updated="updated()"/>
        </td>
        <td class="px-2 py-1 border-dashed border-t border-gray-200 text-left text-sm">
          <div v-if="deadline.assignee_abbreviation" class="text-gray-600 font-bold">
            {{ deadline.assignee_abbreviation }}
          </div>
          <div v-else class="text-gray-500">
            {{ deadline.editor_abbreviation }}
          </div>
        </td>
        <td class="px-4 py-2 border-dashed border-t border-gray-200 text-left">
          <i class="fas fa-check-circle text-green-400" v-if="deadline.is_done"></i>
          {{ deadline.completion_date | toDate }}
        </td>
        <td class="px-4 py-2 border-dashed border-t border-gray-200 text-right">
          <div class="flex justify-end">
            <div @click="edit(deadline)" class="btn btn-secondary btn-small mr-2">
              <i class="fas fa-edit"></i>
            </div>
            <deadline-state :deadline="deadline" v-on:updated="fetchData(false)"/>
          </div>
        </td>
      </tr>
    </table>
    <div class="flex justify-end mt-4">
      <div class="px-4" v-if="pagination['total_pages'] > 1">
        <span v-if="pagination['page'] > 1" @click="toPage(pagination['page'] - 1)">
          <i class="fas fa-caret-left mr-1 text-primary cursor-pointer"></i>
        </span>
        <select v-model="pagination['page']" class="select" @change="fetchData(false)">
          <option v-for='index in pagination["total_pages"]' :key='index' :value="index">Seite {{ index }}</option>
        </select>
        <span v-if="pagination['page'] < pagination['total_pages']" @click="toPage(pagination['page'] + 1)">
          <i class="fas fa-caret-right ml-1 text-primary cursor-pointer"></i>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/locale/de';

export default {
  components: {
    DatePicker
  },
  props: ['dossierId'],
  data() {
    return {
      isDoneFilter: false,
      isImportantFilter: false,
      searchFilter: '',
      isPreliminaryFilter: this.dossierId ? null : false,
      fromDateFilter: null,
      untilDateFilter: null,
      deadlines: [],
      pagination: [],
    }
  },
  filters: {
    toDate: function(value, format = 'DD.MM.YYYY') {
      if (value == null) {
        return value;
      }
      return moment(value).format(format);
    }
  },
  methods: {
    fetchData: function (resetPage) {
      this.$http['get']('/deadlines.json', {
        params: {
          dossier_id: this.dossierId,
          is_done: this.isDoneFilter,
          is_important: this.isImportantFilter,
          search: this.searchFilter,
          // is_preliminary: this.isPreliminaryFilter,
          from_date: moment(this.fromDateFilter, "DD.MM.YYYY").isValid() ? moment(this.fromDateFilter, "DD.MM.YYYY").format("YYYY-MM-DD") : null,
          until_date: moment(this.untilDateFilter, "DD.MM.YYYY").isValid() ? moment(this.untilDateFilter, "DD.MM.YYYY").format("YYYY-MM-DD") : null,
          page: resetPage ? 1 : this.pagination['page'],
        }
      }).then(response => {
        console.log(response.body)
        this.deadlines = response.body.deadlines
        this.pagination = response.body.pagination
        this.$forceUpdate()
      }, response => {
        console.log(response)
      })
    },
    edit: function (deadline) {
      this.$modal.show('deadline-form-modal-'+deadline.id);
    },
    updated: function (event) {
      this.fetchData(false);
      this.$forceUpdate();
    },
    isValidDate: function (d) {
      return d instanceof Date && !isNaN(d);
    },
    toPage: function (page) {
      this.pagination['page'] = page;
      this.fetchData(false);
      this.$forceUpdate();
    },
  },
  mounted() {
    this.fetchData(true);
  }
}
</script>
